import { apiFetch, apiFetchBlob } from 'services/apiClient';
import { Page } from '../../../types/Page';
import {
  Question,
  QuestionBulkCloneRequest,
  QuestionBulkCloneResponse,
  QuestionBulkUpdateRequest,
  QuestionBulkUpdateResponse,
  QuestionImportResponse,
} from '../types/Question';

export const listQuestions = (
  page = 0,
  size = 10,
  sort: string = 'sortOrder,asc',
  query?: string
): Promise<Page<Question>> =>
  apiFetch('/questions?page=' + page + '&size=' + size + (sort ? '&sort=' + sort : '') + (query ? '&' + query : ''));
export const listQuestionsUnpaged = (
  query?: string,
  sort: string = 'sortOrder,asc'
): Promise<Question[]> =>
  apiFetch('/questions/list' + (sort ? '?sort=' + sort : '') + (query ? (sort ? '&' : '?') + query : ''));
// Fetch questions with optional filtering via paginated endpoint
// Defaults: page=0&size=10&sort=sortOrder,asc
export const listQuestionsAll = (
  query?: string,
  page = 0,
  size = 10,
  sort: string = 'sortOrder,asc'
): Promise<Question[]> =>
  apiFetch('/questions?page=' + page + '&size=' + size + (sort ? '&sort=' + sort : '') + (query ? '&' + query : ''))
    .then((res: any) => res?.content ?? []);
export const getQuestion = (id: number): Promise<Question> => apiFetch('/questions/' + id);
export const createQuestion = (data: any): Promise<Question> =>
  apiFetch('/questions', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const updateQuestion = (id: number, data: any): Promise<Question> =>
  apiFetch('/questions/' + id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const deleteQuestion = (id: number): Promise<void> =>
  apiFetch('/questions/' + id, { method: 'DELETE' });

export const reorderQuestions = (items: Array<{ id: number; sortOrder: number }>): Promise<void> =>
  apiFetch('/questions/reorder', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(items),
  });

export const cloneQuestion = (id: number): Promise<Question> =>
  apiFetch('/questions/' + id + '/clone?select=id', { method: 'POST' });

export const bulkCloneQuestions = (data: QuestionBulkCloneRequest): Promise<QuestionBulkCloneResponse> =>
  apiFetch('/questions/bulk-clone', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

export const bulkUpdateQuestions = (data: QuestionBulkUpdateRequest): Promise<QuestionBulkUpdateResponse> =>
  apiFetch('/questions/bulk-update', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

export const downloadQuestionImportTemplate = (reportFormatId: number): Promise<Blob> =>
  apiFetchBlob(`/questions/import-template?reportFormatId=${encodeURIComponent(String(reportFormatId))}`);

export const importQuestionsFromExcel = (reportFormatId: number, file: File): Promise<QuestionImportResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  return apiFetch(`/questions/import?reportFormatId=${encodeURIComponent(String(reportFormatId))}`, {
    method: 'POST',
    body: formData,
  });
};

export const bulkDeleteQuestions = (data: { reportFormatId: number; questionIds: number[] }): Promise<{ deletedQuestionCount: number; deletedAnswerCount: number }> =>
  apiFetch('/questions/bulk-delete', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
